import * as Icons from './Icons'
import React from 'react'

if (process.env.BROWSER) require('../styles/Icon.less')

export default props => {
  const Icon = Icons[props.name]

  return (
    <Icon {...props} />
  )
}
